import React from "react";
import { useTranslation } from "react-i18next";

// MUI
import UploadFileIcon from '@mui/icons-material/UploadFile';

//Custom Components
import ModelTable from "@/ui/Table/ModelTable";
import TableButton from "@/ui/Table/ActionButtons/TableButton";

// Types
import { DCRecord, IDataController, DCFieldValue } from "@/@types/lib/dataController"

type KomunalneObvezeTableProps = {
    dc: IDataController;
    records: Array<DCRecord>;
    handleOpenExportDialog: (selection: string[]) => void;
    selectedProject: DCFieldValue | null;
};

function KomunalneObvezeTable (props: KomunalneObvezeTableProps) {
    const { t } = useTranslation();

    const { dc, records, handleOpenExportDialog } = props;

    // RETURN
    // -------------------------------------------------------------------------------------------
    return (
        <ModelTable
            title={t("titles.komunalne_obveze")}
            records={records}
            dc={dc}
            allowSelection="many"
            viewName="zapisnici"
            allowFilter={true}
            allowExport={true}
            initialPageSize={25}
            onRowAction={() => {}}
            allowRowAction={() => { return true;}}
            >
            <TableButton
                variant="outlined" 
                allow="many"
                selection={[]}
                onClick={(evt, sel) => handleOpenExportDialog(sel)}
                startIcon={<UploadFileIcon />}
            >
                {t("buttons.generate_xml")}
            </TableButton>
        </ModelTable>
    )
}

export default KomunalneObvezeTable